'use client';

import { AlertTriangle, RotateCcw } from 'lucide-react';

export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <main className="min-h-screen bg-background flex items-center justify-center p-5">
    <section className="card-brutal w-full max-w-lg p-7 text-center">
      <div className="w-12 h-12 mx-auto bg-danger/10 border border-danger/30 flex items-center justify-center"><AlertTriangle className="text-danger" /></div>
      <p className="text-label-caps text-accent mt-5">GYMOS · DEMO</p>
      <h1 className="text-display mt-2">ALGO NO SALIÓ BIEN</h1>
      <p className="text-sm text-muted-foreground mt-3">La vista no pudo cargarse. Podés intentar nuevamente sin perder los datos guardados.</p>
      <button onClick={reset} className="btn-primary px-6 py-3 mt-6 inline-flex items-center gap-2"><RotateCcw size={15} />REINTENTAR</button>
    </section>
  </main>;
}
